export default __webpack_public_path__ + "static/media/bittergourd.dadf28ab.png";